import React from 'react';

/*  
 *  *** EXERCISE 2 ***
 *  
 *  Modify this component so that data is loaded from `api/sport` on TestApiController.cs and displayed.
 *  The client MUST NOT make requests directly to the remote REST API endpoint.
 */
function SportsAnswer() {
    // sports details should be loaded and displayed here.
    return <em>Sports details will be displayed here</em>;
}

/** DO NOT MODIFY */
export function Sports() {
    const example_response = {
        "Sports": [
            {
                "SportId": 1,
                "Name": "NFL",
                "Abbreviation": "NFL",
                "TeamGroup": "1",
                "IsActive": true,
                "SortOrder": 1,
                "GetScores": true,
                "Notes": "The National Football League (NFL) is a professional American football league consisting of 32 teams, divided equally between the National Football Conference (NFC) and the American Football Conference (AFC).",
                "SportURL": "/nfl/"
            }
        ]
    };
    return <div>
        <h1>Exercise 2 - Sports</h1>
        <p>
            Please display the Name, Abbreviation, and Notes for the sport with the ID of 10 using this web service:
            <br />
            <a href="https://applicant-api.idevdesign.net/api/sports/">https://applicant-api.idevdesign.net/api/sports/</a>
        </p>

        <p><strong>NOTE:</strong> The request to this service must be executed server-side, and then pulled into the client separately. Please refer to Sports.js and TestApiController.cs</p>

        <p>This is an example response from the API:</p>

        <p>
            {JSON.stringify(example_response) }
        </p>

        <p>You will need the following credentials passed in the header to access the web service:</p>
        <p><strong>apiversion:</strong> 1.0.0 </p>

        <p>
            <strong>___APIKey:</strong> dfhskfdsdfcbcvslkdc

        </p>


        <SportsAnswer />
    </div>
}